<script>
import api from '@/helpers/api'
import { required, email, helpers } from 'vuelidate/lib/validators'
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'supplier-form-dialog.app',
  props: {
    visible: { type: Boolean, default: false },
    preset: { type: Object, default: () => {} }
  },
  data: () => ({
    supplier: {},
    isLoading: false
  }),
  mounted () {
    this.onInit()
  },
  methods: {
    async onInit () {
      let number = await api.suppliers.nextNumber()
      this.supplier = {
        ...this.supplier,
        number
      }
    },
    reset () {
      this.supplier = { ...this.preset }
      if (this.$v) this.$v.$reset()
    },
    onCancel () {
      this.$emit('update:visible', false)

      this.$nextTick(() => {
        this.reset()
      })
    },

    async onSaveHandler (event, validateStep) {
      const validated = validateStep()

      if (validated) {
        try {
          let number = await api.suppliers.nextNumber()
          const { legal_name } = this.supplier
          const {
            attn,
            line1,
            line2,
            zipcode,
            city,
            country_code
          } = this.supplier.billing_address

          const data = {
            ...this.supplier,
            billing_email: this.billing_email
              ? this.supplier.billing_email.split(';')
              : [],
            supplier_number: number
          }

          this.isLoading = true
          let address = await api.addresses.create({
            alias: legal_name,
            attn,
            company_name: legal_name,
            line1,
            line2,
            zipcode,
            city,
            country_code
          })
          let item = await api.suppliers.create({
            ...data,
            billing_address_id: address.id
          })
          this.$bvToast.toast(`Supplier '${item.legal_name}' was created!`, {
            title: 'Supplier Added',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'success',
            autoHideDelay: 1000,
            appendToast: true
          })
          this.$emit('created')
          this.$emit('update:visible', false)
          this.isLoading = false
        } catch (error) {
          this.$bvToast.toast(`${error}!`, {
            title: 'Error',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            autoHideDelay: 1000,
            appendToast: true
          })
          this.isLoading = false
        }
      }
    }
  },
  watch: {
    visible: {
      handler (v) {
        if (v) {
          this.reset()
          this.onInit()
        }
      }
    }
  },
  computed: {
    title () {
      return 'New Supplier'
    },
    steps () {
      let steps = [
        {
          id: uuidv4(),
          title: 'Basic Info',
          icon: 'bx bx-info-circle',
          component: () => import('./general'),
          active: true,
          validated: false
        },
        {
          id: uuidv4(),
          title: 'Billing Address',
          icon: 'bx bx-map',
          component: () => import('./billing_address'),
          active: false,
          validated: false
        }
      ]

      return steps
    }
  }
}
</script>
<template>
  <b-modal
    v-model="visible"
    :title="title"
    centered
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    hide-footer
    size="lg"
  >
    <g-overlay :show="isLoading">
      <g-form-wizard :steps="steps" v-model="supplier">
        <template
          v-slot:buttons="{
            isFirstStep,
            isLastStep,
            nextStep,
            previousStep,
            validateStep
          }"
        >
          <div
            class="d-flex justify-content-between align-items-center mt-2 border-top pt-2"
          >
            <b-btn variant="link" class="mr-2" v-on:click="onCancel">
              Cancel
            </b-btn>

            <div class="d-flex justify-content-end w-100">
              <b-btn
                variant="link"
                class="mr-2 d-flex align-items-center"
                v-on:click="previousStep"
                :disabled="isFirstStep"
              >
                <i class="bx bx-left-arrow mr-2"></i>Back
              </b-btn>

              <b-btn
                variant="primary"
                class="btn-label mr-2"
                v-on:click="onSaveHandler($event, validateStep)"
                v-if="isLastStep"
              >
                <i class="bx bx-save label-icon"></i>
                Create Supplier
              </b-btn>
              <b-btn
                variant="primary"
                class="mr-2 d-flex align-items-center"
                v-on:click="nextStep"
                v-else
              >
                Next<i class="bx bx-right-arrow ml-2"></i>
              </b-btn>
            </div>
          </div>
        </template>
      </g-form-wizard>
    </g-overlay>
  </b-modal>
</template>
